<template>
    <div class="app-content-skeleton" aria-hidden="true">
        <div class="skeleton-card skeleton-header">
            <div class="skeleton-lines">
                <span class="skeleton-line title"></span>
                <span class="skeleton-line subtitle"></span>
            </div>
            <span class="skeleton-button"></span>
        </div>
        <div class="skeleton-toolbar">
            <span class="skeleton-pill"></span>
            <span class="skeleton-pill"></span>
            <span class="skeleton-search"></span>
            <span class="skeleton-button"></span>
        </div>
        <div class="skeleton-grid">
            <div class="skeleton-card" v-for="index in 6" :key="index">
                <span class="skeleton-badge"></span>
                <span class="skeleton-line card-title"></span>
                <span class="skeleton-line"></span>
                <span class="skeleton-line short"></span>
                <div class="skeleton-card-footer">
                    <span class="skeleton-dot"></span>
                    <span class="skeleton-line meta"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>
